import { FormattedMessage } from 'react-intl';

import getUrlToVideo from 'shared/utils/get-url-to-video';
import { VODCSSModules } from 'shared/utils/wix-connect';

import socialNetworkNames from 'widget/constants/social-networks';

import SocialShare from 'widget/player-widget/components/social-share/social-share';

import styles from './share.styl';

import translations from '../../../player/info-overlay/share/translations';


@VODCSSModules(styles)
export default class InfoOverlayShare extends React.Component {

  static propTypes = {
    id: React.PropTypes.string,
    title: React.PropTypes.string,
    description: React.PropTypes.string,
    coverUrl: React.PropTypes.string,

    siteUrl: React.PropTypes.string,
    compId: React.PropTypes.string,

    areElementsRounded: React.PropTypes.bool,

    onShare: React.PropTypes.func,
  };

  render() {
    const { onShare, areElementsRounded, siteUrl, compId, id, title, description, coverUrl } = this.props;

    const networksClassNames = _.pick(styles, _.values(socialNetworkNames));

    const contentToShare = {
      title,
      description,
      coverUrl,
      siteUrl: getUrlToVideo({ id }, { siteUrl, compId }),
    };

    return (
      <div styleName="share-overlay"
           className="qa-player-overlay-share">
        <div styleName="title">
          <FormattedMessage {...translations.share} />
        </div>
        <SocialShare networks={_.values(socialNetworkNames)}
                     areElementsRounded={areElementsRounded}
                     content={contentToShare}
                     onShare={onShare}
                     styleName="social-icons"
                     buttonClassName={styles['share-icon']}
                     linkClassName={styles['share-link']}
                     networksClassNames={networksClassNames} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/player-widget/components/new-player/components/share/share.js